/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import zipWith from 'lodash/zipWith';

import CommunicatorUtility from '../communicator/utility/communicator-utility';
import { dayOfWeekArray } from '../day-of-week';
import { extractTimeParts } from '../iso-time-string';

const { parseDaysOfWeek, validateWeekTimesArray } = CommunicatorUtility;

/**
 * @import { RawRebootTask, RebootCronTask } from '.'
 * @import { ISOTimeString } from '../iso-time-string'
 */

/**
 * @param {Object[]} jsonArray Část odpovědi na obsah zařízení se
 * seznamem všech (nejen restart) úloh.
 * @returns {RebootCronTask[]}
 */
export function parse(jsonArray) {
  return Object.entries(
    Object.groupBy(
      jsonArray.filter(({ type }) => type === 'restart').flatMap(parseOneRaw),
      ({ time }) => time
    )
  ).flatMap(([time, items]) => {
    const [hour, minute] = extractTimeParts(
      /** @type {ISOTimeString} */ (time)
    );
    return `${minute} ${hour} * * ${
      items?.map(({ dayOfWeek }) => dayOfWeek).join(',') ?? '*'
    }`;
  });
}

/**
 * @param {Object} json
 * @returns {RawRebootTask[]}
 */
function parseOneRaw(json) {
  const daysOfWeek = parseDaysOfWeek(json.daysOfWeek);
  const times = validateWeekTimesArray(json.startTimes);
  return zipWith(dayOfWeekArray, times, (dayOfWeek, time) => ({
    dayOfWeek,
    time
  })).filter(({ dayOfWeek }) => daysOfWeek.get(dayOfWeek));
}
